import React, { memo } from "react"
import PropTypes from "prop-types"
import CSlider from "./stencil/cslider-wrapper"
import CText from "./stencil/ctext-wrapper"

const CsrSlider = ({
  children,
  lang,
  dimensions,
  activeSlideIndex,
  radioButtonIdOffset,
}) => {
  const content = require("../data/about.json").csr[lang]

  return (
    <CSlider
      sliderClasses="about-content"
      loadLastSlideItemHalfway={true}
      slides={2}
      collapseOnMobile={true}
      lang={lang}
      path="about"
      activeSlideIndex={activeSlideIndex}
      radioButtonIdOffset={radioButtonIdOffset}
    >
      <div className="carousel-item">
        <c-image
          account="schneckenhof"
          alias="senses-integration/about/Shanghai03_ykuupf"
          crop="fill"
          width={dimensions[0]}
          height={
            dimensions[0] < 641
              ? Math.round(dimensions[1] * 0.5)
              : dimensions[1]
          }
        />
      </div>
      <div className="carousel-item">
        {children}
        <CText
          richText={content}
          maxDesktopText={700}
          maxMobileText={lang === "cn" ? 100 : 250}
          noArrows={dimensions[0] < 641 ? true : false}
          radioButtonIdOffset={41}
          sliderLang={lang}
          viewport={dimensions[0] < 641 ? "mobile" : "desktop"}
        />
      </div>
    </CSlider>
  )
}

CsrSlider.propTypes = {
  children: PropTypes.node,
  lang: PropTypes.string,
  dimensions: PropTypes.array,
  activeSlideIndex: PropTypes.number,
  radioButtonIdOffset: PropTypes.number,
}

export default memo(CsrSlider)
